import React, { useContext, useState } from 'react';
import { AccountContext } from '../AccountContext';
import addDays from 'date-fns/addDays';
import { useMerchantGatewayService, useRefreshConsumerBillingService } from '@app/sdk';

export default function UnmatchedRefundTransaction() {
  const { accountId, setError, billingDate } = useContext(AccountContext);
  const [amount, setAmount] = useState(0.0);
  const [description, setDescription] = useState('A Refund');
  const [refunding, setRefunding] = useState(false as boolean);
  const merchantGatewayService = useMerchantGatewayService();
  const refreshConsumerBillingService = useRefreshConsumerBillingService(accountId);
  const onRefundClicked = async () => {
    try {
      setRefunding(true);
      await merchantGatewayService.refund(accountId, amount, description);
      setTimeout(async () => {
        await refreshConsumerBillingService();
      }, 5000);
      setRefunding(false);
    } catch (error) {
      setRefunding(false);
      setError({ source: 'Unmatched Refund', ...error });
    }
  };

  return (
    <div className="ui card">
      <div className="custom-card-header">Unmatched Refund</div>
      <div className="content">
        <div className="ui form">
          <div className="field">
            <label>Amount</label>
            <div className="ui labeled input">
              <div className="ui label">£</div>
              <input
                type="number"
                placeholder="Amount"
                step=".01"
                disabled={refunding}
                onChange={(e) => setAmount(parseFloat(e.target.value))}
              />
            </div>
          </div>
          <div className="field">
            <label>Description</label>
            <input
              type="text"
              placeholder="Description"
              value={description}
              disabled={refunding}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          {/* <div className="field">
                        <label>Days in Past</label>
                        <div className="ui fluid right labeled input">
                            <input
                                type="number"
                                min="0"
                                value={daysInPast}
                                onChange={(e) => onUpdateDaysInPastUpdate(e.target.value)}
                                disabled={refunding}/>
                            <div className="ui label">
                                Effective: {format(effectiveDate, 'yyyy-MM-dd')}
                            </div>
                        </div>
                    </div>*/}
        </div>
      </div>

      <button type="button" className={`ui primary button ${refunding && 'loading'}`} onClick={() => onRefundClicked()}>
        Refund
      </button>
    </div>
  );
}
